export const createDefaultInfoPage = (
    index: number,
    type: InfoType = 'HOME',
    widgetType: 'Banner' | 'Default' //ATPL DEV OPS VIV
): IInfoCard => ({
    order: index,
    title: { it: '', en: '', ar: '', es: '', fr: '' },
    description: { it: '', en: '', ar: '', es: '', fr: '' },
    image: '',
    type: type,
    buttons: [],
    //ATPL DEV OPS VIV
    layout: [
        {
            visible: true,
            align: 'textRight',
            fontSize: '0px',
            fontColor: '#000000',
            order: 0
        }
    ],
    widget: widgetType, //ATPL DEV OPS VIV
    //ATPL DEV OPS VIV
    bannerCssProp: [
        {
            order: index,
            margin: { margin: 0, top: '', bottom: '', right: '', left: '' }
        }
    ]
})

export const createDefaultNewsCard = (index: number): INewsCard => {
    const timestamp = Date.now()
    const slug = `news-${timestamp}`
    return {
        id: `news-${timestamp}`,
        order: index,
        title: { it: '', en: '', ar: '', es: '', fr: '' },
        previewImage: null,
        content: { it: '', en: '', ar: '', es: '', fr: '' },
        slug: slug,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
    }
}

// Helper function to generate slug from title
export const generateSlugFromTitle = (title: string): string => {
    return title
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '') // Remove special characters
        .replace(/[\s_-]+/g, '-') // Replace spaces, underscores, and multiple hyphens with single hyphen
        .replace(/^-+|-+$/g, '') // Remove leading/trailing hyphens
        .substring(0, 100) // Limit length
}

// Helper function to generate unique slug with random suffix
export const generateUniqueSlug = (title: string): string => {
    return `${generateSlugFromTitle(title)}-${Math.random().toString(36).substring(2, 7)}`
}
